import { render, staticRenderFns } from "./NewPatientWomen.vue?vue&type=template&id=0c4eecca&scoped=true&"
import script from "./NewPatientWomen.vue?vue&type=script&lang=js&"
export * from "./NewPatientWomen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4eecca",
  null
  
)

export default component.exports